import Hero from "@/components/sections/Hero";
import SEO from "@/components/SEO";
import WhyRenVia from "@/components/sections/WhyRenVia";
import Comparison from "@/components/sections/Comparison";
import Lyophilization from "@/components/sections/Lyophilization";
import ClinicalApplications from "@/components/sections/ClinicalApplications";
import VideoCenter from "@/components/sections/VideoCenter";
import ClinicalEvidence from "@/components/sections/ClinicalEvidence";
import SuccessStories from "@/components/sections/SuccessStories";
import AboutSnapshot from "@/components/sections/AboutSnapshot";
import LeadGenCTA from "@/components/sections/LeadGenCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title="Restoring Ocular Health Through Innovation"
        description="RenVia commercializes XcellerEYES — a lyophilized amniotic membrane for advanced ocular surface care. Trusted U.S. partner for Oculus Biologics."
        path="/"
      />
      <Hero />
      <WhyRenVia />
      <Comparison />
      <Lyophilization />
      <ClinicalApplications />
      <VideoCenter />
      <ClinicalEvidence />
      <SuccessStories />
      <AboutSnapshot />
      <LeadGenCTA source="homepage" />
    </div>
  );
}
